import React from 'react'
import useStore from '../hooks/useStore'

function Toast() {
  const { toast } = useStore()

  if (!toast) return null

  return (
    <div className="toast show">
      <span>{toast.icon}</span>
      <span>{toast.message}</span>
    </div>
  )
}

export default Toast